export default __webpack_public_path__ + "static/media/lose.02ef6b82.wav";